/** Konstanta bersama (kategori awal, batasan berkas bukti, tipe bukti). */
/** 18 kategori awal sesuai blueprint, dipakai seeder. */
export const INITIAL_CATEGORIES = [
    "Pembelajaran",
    "Praktikum",
    "Seminar",
    "Workshop",
    "Kuliah Tamu",
    "Penelitian",
    "Pengabdian Masyarakat",
    "Pengembangan Mahasiswa",
    "Organisasi Mahasiswa",
    "Kompetisi",
    "Prestasi",
    "Kerjasama",
    "Kunjungan Industri",
    "Kegiatan Laboratorium",
    "Sertifikasi",
    "Publikasi",
    "Pengembangan Dosen",
    "Kegiatan Internasional",
];
/** Tipe bukti dukung yang boleh dipilih pengguna. */
export const EVIDENCE_TYPES = [
    "Dokumentasi",
    "Undangan",
    "Sertifikat",
    "Daftar Hadir",
    "Laporan",
    "Surat Tugas",
    "Publikasi",
    "Lainnya",
];
/** Batas ukuran satu berkas bukti: 15 MB. */
export const MAX_EVIDENCE_BYTES = 15 * 1024 * 1024;
/** Batas ukuran berkas yang diterima lapisan multipart (sedikit di atas batas app). */
export const MULTIPART_LIMIT_BYTES = 16 * 1024 * 1024;
/**
 * MIME yang diizinkan beserta ekstensi kanoniknya.
 * Pemeriksaan sebenarnya memakai magic-byte (file-type), bukan header dari klien.
 */
export const ALLOWED_EVIDENCE_MIME = {
    "image/jpeg": ".jpg",
    "image/png": ".png",
    "image/webp": ".webp",
    "application/pdf": ".pdf",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document": ".docx",
};
/** Deskripsi singkat untuk pesan galat. */
export const ALLOWED_EVIDENCE_HINT = "JPG, PNG, WEBP, PDF, atau DOCX";
//# sourceMappingURL=constants.js.map